// removed by extract-text-webpack-plugin
module.exports = {"container":"_3qmJ09hyKbB4Mir7z-u64U","grid":"_2f0c-ALXSWKY12snIilc8T","quote":"_lXkGheTl_Fq7dC8LM1Zx","attribute":"_3jjJW3kMUtKKWQj_tPlq8p","button":"_3Ccm6mwzsFzKfF8avADECi","image":"_1eEJtL0EBw-_gK95NgI5vy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Quote/styles.css
// module id = 365
// module chunks = 0